module.exports = __webpack_public_path__ + "img/Pork.3046bebf.jpg";